<template>
  <div class='position-fixed w_100' id='fixed-header' style="z-index: 20; top: 0px;">
    <KwHeaderMenu
      :class="{
        'position-relative': true,
        'page-header--small': isSmall,
      }"
      style="z-index: 20;"
    >
      <template slot='logo'>
        <div @click="onLogoClick">
          <KwKiwitaxiLogoNew class='page-header__logo--new' v-if="isNewDesignTheme"/>
          <KwSvgicon v-else name='logo-new'/>

          <KwSvgicon
            class='page-header__toggle'
            name='chevron'
            width='16'
            height='16'
            :direction="isOpen ? 'down' : 'up' "
            v-if="isMobileView"
          />
        </div>
      </template>
      <template v-if="!isMobileView">
        <KwButton
          slot='left-block'
          styleType='success'
          sizeName='medium'
          @click="goToMain"
        >
          {{ i18n('book_transfer_menu__button') }}
        </KwButton>
        <Balance slot="right-block"/>
        <Language slot="right-block"/>
      </template>
      <Menu slot='menu' v-if="!isMobileView"/>
    </KwHeaderMenu>
    <MobileMenu :show="isOpen" @close='hideMobileMenu'/>
  </div>
</template>

<script>
import _debounce from 'lodash.debounce';

import KwHeaderMenu from '@kiwitaxi/vue-components/dist/KwHeaderMenu';
import KwSvgicon from '@kiwitaxi/vue-components/dist/KwSvgicon';
import KwButton from '@kiwitaxi/vue-components/dist/KwButton';
import KwKiwitaxiLogoNew from '@/components/UI/KwKiwitaxiLogoNew.vue';
import { i18n, locations, newDesignDetector } from '@/mixins';

import { VIEW_SIZE_CODES } from '@/utils/Constants';
import Menu from './components/Menu.vue';
import Language from './components/Language.vue';
import MobileMenu from './components/MobileMenu.vue';
import Balance from './components/Balance.vue';

export default {
  name: 'HeaderComponent',
  components: {
    KwKiwitaxiLogoNew,
    KwHeaderMenu,
    KwSvgicon,
    KwButton,
    Menu,
    Language,
    MobileMenu,
    Balance,
  },
  mixins: [i18n, locations, newDesignDetector],
  data() {
    return {
      isOpen: false,
      isSmall: false,
    };
  },
  computed: {
    isMobileView() {
      return this.$store.getters.viewSizeDown(VIEW_SIZE_CODES.LG);
    },
  },
  mounted() {
    document.addEventListener('scroll', this.checkOffset);
    this.checkOffset();
  },
  beforeDestroy() {
    document.removeEventListener('scroll', this.checkOffset);
  },
  methods: {
    onLogoClick() {
      if (this.isMobileView) {
        if (this.isOpen) {
          this.hideMobileMenu();
        } else {
          this.showMobileMenu();
        }
      } else {
        this.goToMain();
      }
    },
    goToMain() {
      this.locationReplace(window.location.origin);
    },
    showMobileMenu() {
      this.isOpen = true;
    },
    hideMobileMenu() {
      this.isOpen = false;
    },
    checkOffset: _debounce(function throttledCheckOffset() {
      if (window.pageYOffset && !this.isSmall) {
        this.isSmall = true;
      }
      if (!window.pageYOffset && this.isSmall) {
        this.isSmall = false;
      }
    }, 300),
  },
  watch: {
    isMobileView() {
      this.hideMobileMenu();
    },
  },
};
</script>

<style lang='scss'>
@import '~@kiwitaxi/vue-components/dist/styles/ClientMenu.css';

.page-header {
  transition: padding .3s ease;

  &--small {
    padding: 1em;
  }

  @include media-breakpoint-down(md) {
    padding: rem(16);
  }

  .page-header__logo--new {
    width: 45px;
    height: 40px;
  }

  .page-header__toggle {
    width: 16px;
    height: 16px;
  }
}

.balance {
  font-size: 16px;
  border: 1px solid #c8ced4;
  border-radius: 5px;
  margin-right: 2rem;
  padding: 0 10px;
}

</style>



// WEBPACK FOOTER //
// src/components/Header/Bar.vue